<template>
  <div class="flex flex-col items-center">
    <Dataset :key="title" v-for="title in datasetData" :setName="title" class="m-2" />
    <div v-if="!setName" @click="setName = true" @mouseenter="datasetHover = true" class="p-2 flex flex-row items-center cursor-pointer bg-default text-white rounded-full hover:bg-white hover:text-default">
      <p>Add Dataset</p>
      <Icon class="text-2xl pl-2" :icon="['fas', 'plus']" />
    </div>
    <div v-if="setName" class="p-2 flex flex-row items-center cursor-pointer rounded-full bg-white text-default">
      <div>
        <input @keyup.enter="injectDataset" type="text" ref="dataset">
      </div>
    </div>
  </div>
</template>

<script>
import Dataset from '@/components/Dataset'
import { inject } from 'vue'

export default {
  name: 'DatasetHolder',
  setup: function () {
    const dataset = inject('datasets')
    const addDataset = inject('addDataset')
    return {
      dataset,
      addDataset
    }
  },
  data: function () {
    return {
      datasetHover: false,
      setName: false,
      datasetData: this.dataset
    }
  },
  methods: {
    createInput: function () {
      this.setName = true
    },
    injectDataset: function () {
      this.addDataset({ title: (this.$refs.dataset).value, color: Math.floor(Math.random() * 10) })
      this.setName = false
    }
  },
  components: {
    Dataset
  }
}
</script>

<style scoped>

</style>
